import Vue from 'vue'
import VueRouter from 'vue-router'
import ProductsView from '../views/ProductsView.vue'
const AdminView = () => import('../views/AdminView.vue')
const OrderHistoryView = () => import('../views/OrderHistoryView')
const OrderEntryView = () => import('../views/OrderEntryView')
const ProductEventView = () => import('@/views/ProductEventView.vue')

// authentication guard
import { authGuard } from '@/auth/authGuard'
import { getInstance } from '@/auth/auth0-plugin'
import { isAdminUser, PILOT_ROLE } from '@/mixins/user-access'
import { toolkitAlertPayload } from '@/mixins/alert'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: ProductsView,
    meta: {
      requiresAuth: true,
      title: 'Product Catalog'
    }
  },
  {
    path: '/products',
    name: 'products',
    component: ProductsView,
    meta: {
      title: 'Product Catalog',
      requiresAuth: true
    }
  },
  {
    path: '/order-entry',
    name: 'order-entry',
    component: OrderEntryView,
    meta: {
      title: 'Order Entry',
      requiresAuth: true,
      adminOnly: true,
      pilotAccess: true
    }
  },
  {
    path: '/orders',
    name: 'orders',
    component: OrderHistoryView,
    meta: {
      title: 'Order History',
      requiresAuth: true
    }
  },
  {
    path: '/admin',
    name: 'admin',
    component: AdminView,
    meta: {
      requiresAuth: true,
      adminOnly: true,
      title: 'Product Catalog Admin'
    }
  },
  {
    path: '/admin/:tab',
    name: 'adminTab',
    component: AdminView,
    meta: {
      requiresAuth: true,
      adminOnly: true,
      title: 'Product Catalog Admin'
    }
  },
  {
    path: '/admin/event/new',
    component: ProductEventView,
    meta: {
      requiresAuth: true,
      adminOnly: true,
      title: 'Product Event'
    }
  },
  {
    path: '/admin/event/:id',
    name: 'ProductEvent',
    component: ProductEventView,
    meta: {
      requiresAuth: true,
      adminOnly: true,
      title: 'Product Event'
    },
    props: true
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// Enforce route meta access flags (adminOnly / pilotAccess) once authentication
// has resolved — shows the toolkit alert and bounces back instead of landing on the page
const accessGuardedNext = (to, from, next) => (...args) => {
  if (args.length > 0) return next(...args)
  if (to.meta?.adminOnly === true) {
    const auth = getInstance()
    const isAdmin = isAdminUser(auth)
    const isPilot = to.meta.pilotAccess === true && (auth?.userRoles || []).includes(PILOT_ROLE)
    if (!isAdmin && !isPilot) {
      if (router.app) {
        router.app.$nextTick(() => {
          router.app.$emit('alertdialog', toolkitAlertPayload(to.meta.title))
        })
      }
      return next(from.name ? { name: from.name } : { name: 'products' })
    }
  }
  return next()
}

router.beforeResolve(async (to, from, next) => {
  to.meta.referrer = from.name
  if (to.meta) {
    // Use the route's "meta.title" value to assign the page's title
    if (to.meta.title) document.title = `JBG | ${to.meta.title}`
    // For routes requiring authentication ( has "meta.requiresAuth" property )
    if (to.meta.requiresAuth === true) {
      return authGuard(to, from, accessGuardedNext(to, from, next))
    }
    return next()
  } else {
    return next()
  }
})

export default router
